// utils/rtkQueryAdapter.ts
import { QueryReturnValue } from "@reduxjs/toolkit/query";

export async function rtkQueryAdapter<T, E = { message: string }>(
  fn: () => Promise<T>
): Promise<QueryReturnValue<T, E, unknown>> {
  try {
    const data = await fn();
    return { data };
  } catch (err: any) {
    const error: E =
      (err?.response?.data as E) ||
      ({ message: err?.message || "Unknown error" } as E);

    return { error };
  }
}